/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreAzureInstanceDiskInput } from '../models/RestoreAzureInstanceDiskInput';

export class AzureVmInstanceRestoreTarget {
  /**
  * Region to restore to.
  */
  'region': string;
  /**
  * Name of the resource group to restore to.
  */
  'resourceGroupName': string;
  /**
  * Restored VM name.
  */
  'vmName': string;
  /**
  * Size of the restored VM.
  */
  'vmSize': string;
  /**
  * Name of the network interface to use.
  */
  'networkInterface': string;
  /**
  * Tags to apply to the restored instance as key-value pairs, where key and value are both strings. If not provided, defaults to an empty object, with no tags applied.  **Example:** `{\"eon_api_restore\": \"true\"}` 
  */
  'tags'?: { [key: string]: string; };
  'disks': Array<RestoreAzureInstanceDiskInput>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceGroupName",
      "baseName": "resourceGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "vmName",
      "baseName": "vmName",
      "type": "string",
      "format": ""
    },
    {
      "name": "vmSize",
      "baseName": "vmSize",
      "type": "string",
      "format": ""
    },
    {
      "name": "networkInterface",
      "baseName": "networkInterface",
      "type": "string",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "disks",
      "baseName": "disks",
      "type": "Array<RestoreAzureInstanceDiskInput>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureVmInstanceRestoreTarget.attributeTypeMap;
  }

  public constructor() {
  }
}

